/**
 * Parse response from api and return new data props based on user logged in status.
 * @param {any} response /api/account response
 * @param {any} contentfulData Contentful parsed data
 * @param {bool} signedIn Determinates if the user is signed in or not (Default false)
 */
export const profileParser = (response, contentfulData, signedIn = false) => {
  if (response) {
    // eslint-disable-next-line no-param-reassign
    signedIn = response.signed_in;
  }
  const newDataModified = { ...contentfulData };

  // If the user is signed in then return all secondary menu items otherwise
  // return only the items which has flag in contentful showIfUserLoggedIn
  if (newDataModified.secondaryMenu) {
    newDataModified.secondaryMenu = newDataModified
      .secondaryMenu
      .filter(e => (signedIn ? e : ((!!e.showIfUserLoggedIn) === false)));
  }

  // Either user is logged in or not,
  // if only one item exist on contentful field topRightItem then display it.
  // Otherwise return the item which has flag (showIfUserLoggedIn) equal to user logged in status
  if (newDataModified.topRightItems) {
    if (signedIn && newDataModified.topRightItems.length === 1) {
      // eslint-disable-next-line prefer-destructuring
      newDataModified.topRightItem = newDataModified.topRightItems[0];
    } else {
      newDataModified.topRightItem = newDataModified
        .topRightItems
        .find(e => (!!e.showIfUserLoggedIn) === signedIn);
    }
  }

  // Remove duplicate item from secondary menu if already exist in top right menu on mobile screens
  if (window.innerWidth <= 480 && signedIn) {
    if (newDataModified?.topRightItem?.children && newDataModified?.secondaryMenu) {
      newDataModified.secondaryMenu = newDataModified.secondaryMenu
        .filter(
          ({ id: secondaryItemId }) => !(
            newDataModified.topRightItem.children
              .find(({ id: topRightItemId }) => secondaryItemId === topRightItemId)
          ),
        );
    }
  }
  return newDataModified;
};
